(function () {
    'use strict';

    angular
        .module('EventListApp')
        .directive('eaTimer', eaTimer);

    eaTimer.$inject = ['$window', '$interval'];

    function eaTimer($window, $interval) {
        // Usage:
        //     <ea-timer></ea-timer>
        // Creates:
        // 
        return {
            link: link,
            replace: true,
            scope: {
                timeLimit: '=',
            },
            restrict: 'EA',
            template: '<div class="ea-timer">' +
                '<svg  viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">' +
                '<g class="timer-circle">' +
                '<circle class="time-elapsed" cx="50" cy="50" r="45"></circle>' +
                '<path stroke-dasharray="{{circleDasharray}}"' +
                'class="time-remaining" ng-class="pathColor" ' +
                ' d="M 50, 50' +
                'm -45, 0' +
                'a 45,45 0 1,0 90,0' +
                'a 45,45 0 1,0 -90,0"></path>' +
                '</g>' +
                '</svg>' +
                '<span class="time-display" ng-bind="timeLeft"></span>' +
                '</div>',
        };

        function link(scope, element, attrs) {
            let sizes = {
                FULL: 283,
                WARNING: 10,
                ALERT: 5
            };

            let COLOR_CODES = {
                info: {
                    color: "ok"
                },
                warning: {
                    color: "warning",
                    threshold: sizes.WARNING
                },
                alert: {
                    color: "alert",
                    threshold: sizes.ALERT
                }
            };

            let timeLimit = scope.timeLimit || 35;
            let timePassed = 0,
                timeLeft = timeLimit,
                timerInterval = null;

            scope.circleDasharray = sizes.FULL;
            scope.circleDasharray = sizes.FULL;

            startTimer();

            function onTimesUp() {
                $interval.cancel(timerInterval);
            }

            function startTimer() {
                var setUI = function () {
                    timeLeft = timeLimit - timePassed;
                    scope.timeLeft = formatTime(timeLeft);
                    setCircleDasharray();
                    getRemainingPathColor();
                }

                setUI();
                timerInterval = $interval(function () {
                    timePassed = timePassed += 1;
                    setUI();
                    if (timeLeft === 0)
                        onTimesUp();

                }, 1000);
            }

            function formatTime(time) {
                const minutes = Math.floor(time / 60);
                let seconds = time % 60;

                if (seconds < 10) {
                    seconds = '0' + seconds;
                }

                return minutes > 0 ? minutes + ':' + seconds : seconds;
            }

            function getRemainingPathColor() {
                let color = COLOR_CODES.info.color;
                if (timeLeft <= COLOR_CODES.alert.threshold)
                    color = COLOR_CODES.alert.color;
                else if (timeLeft <= COLOR_CODES.warning.threshold)
                    color = COLOR_CODES.warning.color;

                scope.pathColor = color;
            }

            function calculateTimeFraction() {
                let rawTimeFraction = timeLeft / timeLimit;
                return rawTimeFraction - (1 / timeLimit) * (1 - rawTimeFraction);
            }

            function setCircleDasharray() {
                scope.circleDasharray = (
                    calculateTimeFraction() * sizes.FULL
                ).toFixed(0) + ' ' + sizes.FULL;

            }

            element.on('$destroy', function () {
                clearInterval(timerInterval);
            });

        }
    }


})();